import { useIntl } from "react-intl";
import NetlinkingOrderInfoFrom, { IHandleNetlinkingOrderInfo } from "./NetlinkingOrderInfoFrom";
import { IStepsList } from "src/app/components/form/FormikStepper";
import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import {
    UpsertNetlinkingBoostKeywordsSchema,
    UpsertNetlinkingBoostUserKeywordsSchema,
} from "src/app/types/NetlinkigBoost";
import { IData } from "./BulkNetlinkingUtils";
import SemrushKeywords from "./SemrushKeywords";
import { Form } from "react-bootstrap";

export const NetlinkingStepsList = ({
    data,
    handleSelectedKeyword,
    handleNetlinkingOrderInfo,
    handleUserKeyword,
    loading,
    frequency,
}: {
    data?: IData;
    handleSelectedKeyword: (keywords: string) => void;
    handleUserKeyword: (keywords: string) => void;
    handleNetlinkingOrderInfo: IHandleNetlinkingOrderInfo;
    loading: boolean;
    frequency: { options: SimpleFormSelectOption[]; onChange(value: string): void };
}): IStepsList[] => {
    const { formatMessage } = useIntl();

    return [
        {
            title: `${formatMessage({ id: "common.stepper.semRushKeywords" })}`,
            api: "semRushKeywords",
            element: (
                <>
                    <SemrushKeywords
                        data={data}
                        handleSelectedKeyword={handleSelectedKeyword}
                        loading={loading}
                        frequency={frequency}
                    />
                </>
            ),
            validationSchema: UpsertNetlinkingBoostKeywordsSchema,
        },
        {
            title: `${formatMessage({ id: "common.stepper.userKeywords" })}`,
            api: "userKeywords",
            element: (
                <>
                    <div className={`stepper-item current mb-2`}>
                        <div className="stepper-wrapper">
                            <div className="stepper-icon w-40px h-40px">
                                <i className="stepper-check fas fa-check"></i>
                                <span className="stepper-number">{2}</span>
                            </div>
                            <div className="stepper-label">
                                <h3 className="stepper-title">
                                    {formatMessage({ id: "common.stepper.userKeywords" })}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <Form.Control
                        name="userKeywords"
                        as="textarea"
                        rows={20}
                        value={data?.userKeywords}
                        onChange={(ev) => handleUserKeyword(ev.currentTarget.value)}
                    />
                </>
            ),
            validationSchema: UpsertNetlinkingBoostUserKeywordsSchema,
        },
        {
            title: `${formatMessage({ id: "common.stepper.orderInfo" })}`,
            api: "orderInfo",
            element: (
                <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
                    <div className={`stepper-item current mb-2`}>
                        <div className="stepper-wrapper">
                            <div className="stepper-icon w-40px h-40px">
                                <i className="stepper-check fas fa-check"></i>
                                <span className="stepper-number">{3}</span>
                            </div>
                            <div className="stepper-label">
                                <h3 className="stepper-title">
                                    {formatMessage({ id: "common.stepper.orderInfo" })}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <NetlinkingOrderInfoFrom
                        netlinkingOrderInfo={data?.netlinkingOrderInfo}
                        handleNetlinkingOrderInfo={handleNetlinkingOrderInfo}
                        loading={loading}
                        url={data?.url}
                    />
                </div>
            ),
            validationSchema: UpsertNetlinkingBoostKeywordsSchema,
        },
    ];
};
